module.exports = __webpack_public_path__ + "img/DOM.3d7b2e2b.gif";